import { arrayOf, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Table from '../../../generic/Table';
import Titled from '../../../layout/Titled';
import { contactListShape } from '../../../prop-types';
import api from '../../../REST/api';
import withResolved from '../../../REST/with-resolved';
import contactListColumns from '../contact-lists-columns';

const ListOfContactLists = ({ data, titleSize, title }) => {
  return (
    <Titled
      title={title}
      size={titleSize}
      actions={
        <Link className="btn btn-secondary" to="/contacts/contact-lists/add">
          Create Contact list
        </Link>
      }
    >
      <Table data={data} columns={contactListColumns} minRows={2} />
    </Titled>
  );
};

ListOfContactLists.propTypes = {
  titleSize: string,
  data: arrayOf(contactListShape.isRequired).isRequired,
  title: string,
};

ListOfContactLists.defaultProps = {
  titleSize: undefined,
  title: 'Contact lists',
};

export default withResolved({
  query: api.getContactLists,
  deriveQueryArgs: ({ contactId }) => ({
    search: { contactId },
  }),
  as: 'data',
})(ListOfContactLists);
